import DCMapPage from './pages/DCMap.page';

DCMapPage.path = '/map';

export default {
  pages: {
    DCMapPage,
  }
};
